import { Component } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-seo-off-page-recommendations-list',
  templateUrl: './seo-off-page-recommendations-list.component.html',
  styleUrls: ['./seo-off-page-recommendations-list.component.css'],
})
export class SeoOffPageRecommendationsListComponent {
  url: string = 'seoOffpageRecommendations';
  data: Array<any> = [];
  searchText = '';
  filteredData: Array<any> = [];
  searchSuggestions: string[] = [];
  currentPage: number = 1;
  morePages: boolean = true;
  itemsPerPage: number = 50;
  modalTitle: string = '';
  modalContent: string | null = null;

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
    
  ];

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.dataService
      .getDataTwo(this.url, '', '', this.currentPage, this.itemsPerPage)
      .subscribe((response) => {
        if (response.data) {
          this.data = response.data.sort((a: any, b: any) => {
            return (
              new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
            );
          });
          this.filteredData = [...this.data];
          this.updateSuggestions();
        }
      });
  }

  approve(id: string): void {
    if (!confirm('¿Desea aprobar esta recomendación?')) {
      return;
    }
    this.dataService
      .putData(`${this.url}/${id}/approve`, {})
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  discard(id: string): void {
    if (!confirm('¿Desea descartar esta recomendación?')) {
      return;
    }
    this.dataService
      .putData(`${this.url}/${id}/discard`, {})
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  convertToCampaign(id: string): void {
    if (!confirm('¿Desea convertir esta recomendación en una campaña?')) {
      return;
    }
    this.dataService
      .postData(`${this.url}/${id}/convert-to-campaign`, {})
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  filter() {
    const texto = this.searchText.trim().toLowerCase();
    if (!texto) {
      this.filteredData = [...this.data];
    } else {
      this.filteredData = this.data.filter((item) => {
        return (
          (item.targetKeyword &&
            item.targetKeyword.toLowerCase().includes(texto)) ||
          (item.service && item.service.toLowerCase().includes(texto)) ||
          (item.city && item.city.toLowerCase().includes(texto)) ||
          (item.recommendationType &&
            item.recommendationType.toLowerCase().includes(texto))
        );
      });
    }
  }

  updateSuggestions() {
    const sugerenciasSet = new Set<string>();
    this.data.forEach((item) => {
      if (item.targetKeyword) sugerenciasSet.add(item.targetKeyword);
      if (item.recommendationType) sugerenciasSet.add(item.recommendationType);
    });
    this.searchSuggestions = Array.from(sugerenciasSet).filter(Boolean);
  }

  getStatusBadgeClass(status: string): string {
    switch (status) {
      case 'new':
        return 'badge-info';
      case 'approved':
        return 'badge-primary';
      case 'converted_to_campaign':
        return 'badge-success';
      case 'discarded':
        return 'badge-danger';
      case 'done':
        return 'badge-dark';
      default:
        return 'badge-light';
    }
  }

  getPriorityBadgeClass(priority: string): string {
    switch (priority) {
      case 'critical':
        return 'badge-danger';
      case 'high':
        return 'badge-warning';
      case 'medium':
        return 'badge-info';
      case 'low':
        return 'badge-secondary';
      default:
        return 'badge-light';
    }
  }

  showModal(title: string, content: string) {
    this.modalTitle = title;
    this.modalContent = content;
  }

  closeModal() {
    this.modalContent = null;
  }
}
